import { FormControlLabel } from '@mui/material';
import React from 'react';
import MuiCheckbox, { MuiCheckboxProps } from '../../../../mui/MuiCheckbox';

export type InvoiceEditAllowGratuityProps = Pick<
	MuiCheckboxProps,
	'checked' | 'onChange' | 'disabled'
>;

export const InvoiceEditAllowGratuity: React.FC<
	InvoiceEditAllowGratuityProps
> = ( props ) => (
	<FormControlLabel
		control={
			<MuiCheckbox
				{ ...props }
				slotProps={ { input: { 'data-cy': 'allows-gratuity' } } }
			/>
		}
		label='Allow gratuity on the final payment'
	/>
);
